interface Props {
  size: number;
}
const save = ({ size }: Props) => {
  return (
    <svg height="24" viewBox="0 -960 960 960" width="24" fill="#667085">
      <path
        stroke="#667085"
        d="M840-680v480q0 33-23.5 56.5T760-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h480l160 160Zm-80 34L646-760H200v560h560v-446ZM480-240q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM240-560h360v-160H240v160Zm-40-86v446-560 114Z"
      />
    </svg>
  );
};

export default save;
